/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetDocumentRequest = {
  /**
   * The unique ID of the document to retrieve
   */
  docId: string;
  /**
   * The name of the index containing the document
   */
  indexName: string;
  /**
   * The maximum number of chunks to return in the response
   */
  limit?: number | undefined;
  /**
   * A cursor to fetch the next set of chunks if the document is paginated
   */
  cursor?: string | undefined;
};

/** @internal */
export const GetDocumentRequest$inboundSchema: z.ZodType<
  GetDocumentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  doc_id: z.string(),
  index_name: z.string(),
  limit: z.number().int().optional(),
  cursor: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "doc_id": "docId",
    "index_name": "indexName",
  });
});

/** @internal */
export type GetDocumentRequest$Outbound = {
  doc_id: string;
  index_name: string;
  limit?: number | undefined;
  cursor?: string | undefined;
};

/** @internal */
export const GetDocumentRequest$outboundSchema: z.ZodType<
  GetDocumentRequest$Outbound,
  z.ZodTypeDef,
  GetDocumentRequest
> = z.object({
  docId: z.string(),
  indexName: z.string(),
  limit: z.number().int().optional(),
  cursor: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    docId: "doc_id",
    indexName: "index_name",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetDocumentRequest$ {
  /** @deprecated use `GetDocumentRequest$inboundSchema` instead. */
  export const inboundSchema = GetDocumentRequest$inboundSchema;
  /** @deprecated use `GetDocumentRequest$outboundSchema` instead. */
  export const outboundSchema = GetDocumentRequest$outboundSchema;
  /** @deprecated use `GetDocumentRequest$Outbound` instead. */
  export type Outbound = GetDocumentRequest$Outbound;
}

export function getDocumentRequestToJSON(
  getDocumentRequest: GetDocumentRequest,
): string {
  return JSON.stringify(
    GetDocumentRequest$outboundSchema.parse(getDocumentRequest),
  );
}

export function getDocumentRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetDocumentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDocumentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDocumentRequest' from JSON`,
  );
}
